import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { isArray } from "util";
import { RoleEnum } from "../shared/Models/enums/RoleEnum";

@Injectable({
  providedIn: "root",
})
export class TokenService {
  jwtHelperService: JwtHelperService;
  constructor() {
    this.jwtHelperService = new JwtHelperService();
  }

  getToken(): string {
    return localStorage.getItem("token");
  }

  deleteToken(): void {
    localStorage.removeItem("token");
  }

  setToken(token: string) {
    localStorage.setItem("token", token);
  }

  getPayload() {
    const token = this.getToken();
    if (token) return this.jwtHelperService.decodeToken(token);

    return null;
  }

  isTokenExpired() {
    let token = this.getToken();

    if (token != null) return this.jwtHelperService.isTokenExpired(token);
    return false;
  }

  getRoles(): Array<string> {
    const payload = this.getPayload();
    if (payload)
      if (
        payload.hasOwnProperty(
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        )
      ) {
        const roles =
          payload[
            "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
          ];
        if (isArray(roles)) return roles;

        return [roles];
      }

    return [];
  }

  getAuthUserId() {
    const payload = this.getPayload();
    if (payload) if (payload.hasOwnProperty("userId")) return payload.userId;

    return null;
  }

  getPayloadAttribute(key: string) {
    const payload = this.getPayload();
    if (payload) if (payload.hasOwnProperty(key)) return payload[key];

    return null;
  }

  isSurveyor() {
    return this.getRoles().includes(RoleEnum.Surveyor);
  }

  isPlanner() {
    return this.getRoles().includes(RoleEnum.Planner);
  }

  isValidator() {
    return this.getRoles().includes(RoleEnum.Validator);
  }

  isManager() {
    return this.getRoles().includes(RoleEnum.Manager);
  }

  isAdmin() {
    return this.getRoles().includes(RoleEnum.Admin);
  }

  hasSomeRole(rolesToCheck: string[]): boolean {
    const roles = this.getRoles();
    return roles.some((r) => rolesToCheck.includes(r));
  }
}
